import {notNull} from '../../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {HeaderHeightCalculator} from '../../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/components/headerHeightCalculator';
import {TarifDetail} from '../../tarifDetail';
import {ScrollToElement} from '../../common/scrollToElement';

export class Articlelist {
    private readonly viewRoot: HTMLElement;

    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;
        this.registerEventListeners();
    }

    private registerEventListeners() {
        this.openFilterMobile();
        this.closeFilterMobile();
        this.changeColorTarifdetail();
        this.changeColor();
    }

    private openFilterMobile() {
        const openFilterButtons = this.viewRoot.querySelectorAll<HTMLAnchorElement>('.form_moduleCms_articlelist .filtern');
        openFilterButtons.forEach((element) => {
            element.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();

                notNull(document.querySelector('body')).classList.add('no-scroll');
                notNull(document.querySelector('html')).classList.add('no-scroll');

                const cmsRoot = element.closest('.cms-module-root');
                if (!cmsRoot) {
                    return;
                }
                const filter = cmsRoot.querySelector<HTMLElement>('.cms-article-list-filter');
                if (filter) {
                    filter.style.display = 'block';
                }
                const headline = cmsRoot.querySelector<HTMLElement>('.filter-mobile-headline');
                if (headline) {
                    headline.scrollIntoView();
                }
            });
        });
    }

    private closeFilterMobile() {
        // geht zu wenn man auf der close-icon oder auf die ganze filterzeile klickt
        const closeFilterButtons = this.viewRoot.querySelectorAll<HTMLAnchorElement>(
            '.form_moduleCms_articlelist .filter-mobile-headline, .form_moduleCms_articlelist .closeFilter',
        );
        closeFilterButtons.forEach((element) => {
            element.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();

                notNull(document.querySelector('body')).classList.remove('no-scroll');
                notNull(document.querySelector('html')).classList.remove('no-scroll');

                const cmsRoot = element.closest('.cms-module-root');
                if (!cmsRoot) {
                    return;
                }
                const filter = cmsRoot.querySelector<HTMLElement>('.cms-article-list-filter');
                if (!filter) {
                    return;
                }

                filter.style.display = 'none';
                const row = filter.closest<HTMLElement>('.row');
                if (row) {
                    new ScrollToElement(row);
                }
            });
        });
    }

    private changeColor() {
        const farbBubbels = this.viewRoot.querySelectorAll<HTMLElement>('.moduleCms_articlelist .colors_memory li');
        farbBubbels.forEach((element) => {
            element.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.changeArticle(element);
            });
        });
    }
    private changeArticle(element: HTMLElement): void {
        const artid = element.dataset.artid;

        if (!artid) {
            return;
        }

        const imgurl = element.dataset.imageurl;
        if (imgurl) {
            const img = new Image();
            img.src = imgurl;
        }

        const container = element.closest('li.articlebox') as HTMLElement | null;
        if (!container) {
            return;
        }

        const apiurl = '/modulecmsapi/api_articlelist_change/' + artid;

        const settings: RequestInit = {
            method: 'POST',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            cache: 'default',
            credentials: 'same-origin',
        };

        fetch(apiurl, settings)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                return Promise.reject('Fehlerhafte Antwort vom Server.');
            })
            .then((content) => {
                if (content) {
                    container.innerHTML = content;

                    container.querySelectorAll<HTMLElement>('.colors_memory li').forEach((el) => {
                        el.addEventListener('click', (event) => {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            this.changeArticle(el);
                        });
                    });
                }
            });
    }

    private changeColorTarifdetail() {
        const farbBubbels = this.viewRoot.querySelectorAll<HTMLElement>('.detail-dialog.articleliste .moduleCms_articlelist .colors_memory li');
        farbBubbels.forEach((element) => {
            element.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.changeArticleTarifdetail(element);
            });
        });
    }
    private changeArticleTarifdetail(element: HTMLElement): void {
        const artid = element.dataset.artid;

        if (!artid) {
            return;
        }

        const container = element.closest('li.articlebox') as HTMLElement | null;
        if (!container) {
            return;
        }

        const containertrigger = container.closest('ul') as HTMLElement | null;
        if (!containertrigger) {
            return;
        }

        const tarifid = container.dataset.tarifid;
        if (!tarifid) {
            return;
        }

        const apiurl = `/tarif/api_article_change/${artid}/${tarifid}`;

        const settings: RequestInit = {
            method: 'POST',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            cache: 'default',
            credentials: 'same-origin',
        };

        fetch(apiurl, settings)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                return Promise.reject('Fehlerhafte Antwort vom Server.');
            })
            .then((content) => {
                if (content && container) {
                    container.outerHTML = content;
                    const updatedContainer = containertrigger.querySelector(`li.articlebox[data-articleid="${artid}"]`) as HTMLElement | null;
                    if (!updatedContainer) {
                        return;
                    }
                    containertrigger.querySelectorAll<HTMLElement>('.colors_memory li').forEach((el) => {
                        el.addEventListener('click', (event) => {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            this.changeArticleTarifdetail(el);
                        });
                    });

                    if (typeof TarifDetail === 'function') {
                        new TarifDetail(updatedContainer);
                    }
                }
            });
    }
}
